<template xmlns:v-on="http://www.w3.org/1999/xhtml">
  <div id="templatePane">
    <div class="hero-section shade-40">
      <div class="hero-section-text row column">
        <h1>{{ $t('lang.index.hero-title') }}</h1>
      </div>
    </div>
    <section id="mainContent" class="row column content" v-if="loaded">
      <h2>{{ $t('lang.index.lets-get-started') }}</h2>
      <div v-if="tokenExists">
        <p>{{ $t('lang.index.welcome-to-workplace') }}</p>
        <p>{{ $t('lang.index.to-get-started') }}</p>
        <p>{{ $t('lang.index.if-youre-ready') }}</p>
        <p>
          <a href="#" class="button" v-on:click="pushToPhoneNumberPage">{{ $t('lang.index.lets-start') }}</a>
        </p>
      </div>
      <div v-else>
        <p>{{ $t('lang.index.welcome-to-workplace') }}</p>
        <p>{{ $t('lang.index.to-get-started') }}</p>
        <p>{{ $t('lang.index.firstly-we-need') }}</p>
        <p>
          <a href="#" class="button" v-on:click="signIn">{{ $t('lang.index.sign-in') }}</a>
        </p>
      </div>
      <!-- <h2>Down for maintenance</h2>
      <p>We're sorry, we're currently experiencing some issues and Workplace signup is unavailable, please try again later</p> -->
    </section>
    <section v-else>
      <div class="content">
        <img class="loading" src="/static/images/ajax-loader.gif">
      </div>
    </section>
  </div>
</template>

<script>
var ES6Promise = require("es6-promise")
ES6Promise.polyfill()
import "es7-object-polyfill";
require('array.prototype.find').shim();
import Vue from 'vue'

import authentication from '../../authentication'
import router from '../../router'
import api from '../../api/index.js'

export default {
  name: 'Index',
  title: 'Workplace - Lets get started',
  data: function () {
    return {
      user: "",
      userInterval: "",
      loaded: false,
      tokenExists: false,
    }
  },
  methods: {
    signIn: function (event) {
      authentication.initialize();
    },
    pushToPhoneNumberPage: function () {
      if (this.userAcceptedLicense()) {
        router.push('phone-number');
      } else {
        router.push('user-agreement-notice');
      }
    },
    checkUserEligibility: function () {
      if (authentication.getCachedToken()) {
        authentication.getCachedToken().then(response => {
          var token = response.rawIdToken;
          api.getUserEligibility(token)
            .then(response => {
              this.loaded = true;
            })
            .catch(error => {
              router.push(this.getErrorRedirect(error))
            })
        })
      } else {
        this.loaded = true;
      }
    },
    userCameFromEnterPhoneNumber() {
      return localStorage.enterPhoneNumber;
    },
    userAcceptedLicense() {
      return localStorage.acceptedLicense;
    }
  },
  created() {
    if (authentication.isCallback(window.location.hash)) {
      authentication.handleWindowCallback(window.location.hash)

      if (this.userAcceptedLicense()) {
        if (this.userCameFromEnterPhoneNumber()) {
          router.push('enter-phone-number');
        } else {
          router.push("phone-number");
        }
      } else {
        router.push("user-agreement-notice")
      }

    } else {
      if (authentication.getCachedToken() !== null) {
        this.tokenExists = true;
        this.checkUserEligibility();
      } else {
        this.loaded = true;
      }
    }
  }
}

</script>

<style>
.loading {
  margin-left: auto;
  margin-right: auto;
  display: block;
  margin-top: 50px;
  margin-bottom: 50px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .2s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}

.content {
  min-height: 150px;
}</style>